import {useQuery} from "@tanstack/react-query";
import {getLiveGamesService} from "../../services/games/liveGames/getLiveGames.service";

export const useGetLiveGames = () => {
  const {data, isSuccess, isLoading, isError, error} = useQuery({
    queryKey: ["liveGames"],
    queryFn: getLiveGamesService,
    staleTime: 5 * 60 * 1000, // 5 minutes (was 300ms — likely a typo)
  });

  const liveGames = data?.data?.items || [];

  const extractedData = liveGames.map(item => {
    const id = item[0][0];
    const description = item[0][1];
    const matchDetails = item[1];
    return {id, description, matchDetails};
  });

  return {extractedData, isSuccess, isError, error, isLoading};
};
